import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando componente
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Card from '~/components/Card';
import Select from '~/components/Form/Select';
import Load from '~/components/Load';

import { Container } from './styles';

export default function UsersEdit({ match }) {
  const statusOptions = [
    {
      value: 1,
      label: 'Ativo'
    },
    {
      value: 2,
      label: 'Inativo'
    }
  ]

  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [carregar, setCarregar] = useState(false);
  const [timeId, setTimeId] = useState(0);
  const [providerId, setProviderId] = useState(0);
  const [dado, setDado] = useState([]);
  const [times, setTimes] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [status, setStatus] = useState([])
  const [statusId,  setStatusId] = useState()
  const user = useSelector(state => state.user.profile);

  const getDados = useCallback(async () => {
    setLoading(true);
    const { id } = match.params;
    // Pegando os dados do usuario
    const responseUser = await api.get(`/user/${id}`);

    // Pegando times
    const responseTimes = await api.get('/times-select');
    const dataTime = responseTimes.data.map(time => ({
      value: time.id,
      label: time.name,
    }));

    const dataSelectTime = dataTime.filter(time => {
      return time.value === Number(responseUser.data.time_id);
    });


    // Pegando o cargo
    let dataCargo;
    if (user.provider === '2') {
      dataCargo = [
        {
          value: 1,
          label: 'Gerente',
        },
        {
          value: 3,
          label: 'Normal',
        },
      ];
    } else if (user.provider === '4') {
      dataCargo = [
        {
          value: 1,
          label: 'Gerente',
        },
        {
          value: 2,
          label: 'Diretor',
        },
        {
          value: 3,
          label: 'Normal',
        },
        {
          value: 4,
          label: 'Bamboo',
        },
      ];
    }


    const dataSelectCargo = dataCargo.filter(cargo => {
      return cargo.value === Number(responseUser.data.provider);
    });

    const statusDataSelect = statusOptions.filter(statusData => {
      return statusData.value === Number(responseUser.data.status)
    })

    setDado(responseUser.data);
    setCargos(dataCargo);
    setStatus(statusOptions)
    setStatusId(statusDataSelect[0])
    setProviderId(dataSelectCargo[0]);
    setTimes(dataTime);
    setTimeId(dataSelectTime[0]);
    setLoading(false);
  }, [match.params, user.provider]);

  useEffect(() => {
    const abortController = new AbortController();
    getDados();

    return function cleanup() {
      abortController.abort();
    };
  }, [getDados]);

  /**
   * Funcoes
   */

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      let schema;

      if (user.provider === '4') {
        schema = Yup.object().shape({
          time_id:
            data.time_id === undefined
              ? null
              : Yup.string('Selecione um time').required('Selecione um time'),
          name: Yup.string().required('Preencha o campo nome'),
          email: Yup.string()
            .email('Preencha um e-mail valido')
            .required('Preencha o campo e-mail'),
          provider:
            data.provider === undefined
              ? null
              : Yup.string('Selecione um cargo').required('Selecione um cargo'),
          hora_abertura: Yup.string().required(
            'Preencha o campo hora de entrada do usuario'
          ),
          hora_encerramento: Yup.string().required(
            'Preencha o campo hora de saida do usuario'
          ),
        });
      } else {
        schema = Yup.object().shape({
          name: Yup.string().required('Preencha o campo nome'),
          email: Yup.string()
            .email('Preencha um e-mail valido')
            .required('Preencha o campo e-mail'),
          provider:
            data.provider === undefined
              ? null
              : Yup.string('Selecione um cargo').required('Selecione um cargo'),
          hora_abertura: Yup.string().required(
            'Preencha o campo hora de entrada do usuario'
          ),
          hora_encerramento: Yup.string().required(
            'Preencha o campo hora de saida do usuario'
          ),
        });
      }

      await schema.validate(data, {
        abortEarly: false,
      });

      const timeSelectId = user.provider === '4' ? data.time_id : user.time_id;

      await api.put(`/user/${dado.id}`, {
        time_id: timeSelectId,
        name: data.name,
        email: data.email,
        password: data.password,
        provider: data.provider,
        status: data.status,
        hora_abertura: data.hora_abertura,
        hora_encerramento: data.hora_encerramento,
      });

      toast.success('Usuario editado com sucesso');
      history.push('/user');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar o usuario, verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Editar Usuário</h4>
      <Card>
        <Form
          ref={inputRef}
          onSubmit={handlerSubmit}
          autoComplete="off"
          initialData={dado}
        >
          <Input icon="MdPerson" label="Nome" name="name" type="text" />
          <Input icon="MdMail" label="E-mail" name="email" type="text" />
          {user.provider !== '1' && user.provider !== '3' && (
            <>
              <Select
                name="time_id"
                labelSelect="Times"
                options={times}
                onChange={e => setTimeId(e)}
                defaultValue={timeId}
              />
              <Select
                name="provider"
                labelSelect="Cargo"
                options={cargos}
                onChange={e => setProviderId(e)}
                defaultValue={providerId}
              />
            </>
          )}
          <Select
            name="status"
            labelSelect="Status"
            options={status}
            onChange={e => setStatusId(e)}
            defaultValue={statusId}
            
          />
          <Input
            icon="MdAccessTime"
            label="Hora de entrada do usuario"
            name="hora_abertura"
            type="time"
          />
          <Input
            icon="MdAccessTime"
            label="Hora de saida do usuario"
            name="hora_encerramento"
            type="time"
          />
          <Button tamanho="40px" load={carregar}>
            Editar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

UsersEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
